import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Modal from '../common/Modal'
import { Grid, GridColumn, GridRow } from 'semantic-ui-react'
import { Button } from 'react-dxd-components'
import REQUEST_STATUS from '../../state/common/REQUEST_STATUS'
import { fetchEoiRules } from '../../state/reducers/fetchEoiRules'
import toStateSpecialAbbreviation from '../../util/toStateSpecialAbbreviation'
import selectedCoverages from '../../util/selectedCoverages'

/**
 * Listen to both situsState and employer address state changes.
 * If both are populated but different values, we know the user used the suggested address and changed the employer state.
 * In this event, we need to fetch the new/correct health questions for the new employer state value
 */
const SitusStateChangeListenerModal = () => {

  const dispatch = useDispatch()
  const [open, setOpen] = useState(false)
  const employerOptions = useSelector(state => state.form.segments.employer.fields)
  const { options, context: { appDataRequestStatus: status } } = useSelector(state => state.form)

  useEffect(() => {
    if (options.situsState.value && employerOptions.address.state.value && (options.situsState.value !== employerOptions.address.state.value)) {
      setOpen(true)
      dispatch(fetchEoiRules({
        state: toStateSpecialAbbreviation(employerOptions.address.state.value, options.groupType.value),
        groupNumber: employerOptions.groupNumber.value,
        selectedCoverages: selectedCoverages(options)
      }))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [options.situsState.value, employerOptions.address.state.value])

  useEffect(() => {
    console.log('status change: ', status)
  }, [status])

  return <Modal
    id='state-change-modal'
    open={open}
  >
    <Grid>
      <GridRow>
        <GridColumn width={16}>
          The Employer State initially entered is different than the State in the Employer address. Please wait while
          the associated Health Questions are retrieved. Please note that some information may need to be entered again.
        </GridColumn>
        <GridColumn computer={4} tablet={6} mobile={16} floated='right'>
          <Button
            loading={[REQUEST_STATUS.NOT_STARTED, REQUEST_STATUS.IN_PROGRESS].includes(status)}
            disabled={[REQUEST_STATUS.NOT_STARTED, REQUEST_STATUS.IN_PROGRESS].includes(status)}
            onClick={() => setOpen(false)}
          >
            Okay
          </Button>
        </GridColumn>
      </GridRow>
    </Grid>
  </Modal>
}

export default SitusStateChangeListenerModal